const helpYear = "2025"; // Year variable

const helpLinks = {
  default: `https://docs.cimco.com/en/docs/mnt/${helpYear}/introduction/`,
  "/mnt/": `https://docs.cimco.com/en/docs/mnt/${helpYear}/introduction/`,
  "/fault-error": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/error-reporting/`,
  "/service-reports": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/error-reporting/service-reports-active/`,
  "/time-reports": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/error-reporting/service-reports-closed/`,
  "/maintenance-schedule": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/maintenance/`,
  "/inventory": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/inventory/`,
  "/personnel": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/personnel/`,
  "/add-machine": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/machines/`,
  "/machine-priority": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/machine-priority/`,
  "/notification-input": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/notifications/`,
  "/settings": `https://docs.cimco.com/en/docs/mnt/${helpYear}/sections/settings/`,
};

// Function to return the correct help link
const getHelpLink = (path) => {
    console.log("Getting help link for:", path); // ✅ Debugging output
    const cleanedPath = path.replace(/\/\d+$/, "/");
    const resolvedUrl = helpLinks[cleanedPath] || helpLinks.default;
    console.log("Resolved Help URL:", resolvedUrl); // ✅ Check what is returned
    return resolvedUrl;
  };

export { getHelpLink };
